export const DISALLOW = "DISALLOW";
export const ON_REQUEST = "ON_REQUEST";
export const ALWAYS = "ALWAYS";

export const PERMISSION_OPTIONS = [DISALLOW, ON_REQUEST, ALWAYS]
